// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "LazyIdentificationForm" + "." + "2804555c1fc49b1e" + ".css"
}